export default function index() {
	return (
		<div>
			<h2>N&atilde;o Encontrado</h2>
		</div>
	);
}
